import { atom } from 'jotai/index';
import { subscriberSetAtomFamily } from '@store/atoms/mqtt/subscription/subscriptionAtoms';
import { scheduleDebouncedUnsubscribeAtom } from '@store/atoms/mqtt/subscription/debouncedUnsubscribeAtom';
import { setDebugLabels } from '@store/atoms/mqtt/utils/atomUtils';
import {
  validateUnsubscriptionTopic,
  checkSubscriberExists,
  scheduleUnsubscribe,
} from '@store/atoms/mqtt/utils/subscriptionUtils';

export const unsubscribeWithLifecycleAtom = atom(
  null,
  (
    get,
    set,
    {
      topic,
      subscriberId,
      immediate = false,
    }: {
      topic: string;
      subscriberId: string;
      immediate?: boolean;
    },
  ) => {
    if (validateUnsubscriptionTopic(topic, subscriberId)) {
      return;
    }

    const currentSubscribers = get(subscriberSetAtomFamily(topic));

    if (checkSubscriberExists(currentSubscribers, subscriberId, topic)) {
      return;
    }

    scheduleUnsubscribe(
      set,
      scheduleDebouncedUnsubscribeAtom,
      topic,
      subscriberId,
      immediate,
    );
  },
);

setDebugLabels({
  unsubscribeWithLifecycleAtom,
});
